import { useLinkedContext } from '@context/LinkedItemZoneContext'
import * as Accordion from '@radix-ui/react-accordion'
import clsx from 'clsx'
import { useState, useEffect } from 'react'
import { useAppStore } from '@store'

export default function LinkedGroupEditor() {
  const {
    highlighted,
    modelo,
    isModel,
    centerInfo,
    acabado,
    setAcabado,
    actions: { handleGroupClick },
    search,
  } = useLinkedContext()
  const regexp = new RegExp(search, 'gi')
  const [controlledValues, setControlledValues] = useState('')

  const handleRootChange = (value: string) => {
    setControlledValues(controlledValues !== value ? value : '')
  }

  useEffect(() => {
    const store = useAppStore.getState()
    const currentObjectID = store.currentObjectID

    if (highlighted && highlighted.startsWith('linkedSon_')) {
      const childItem = store.items.get(highlighted)
      if (childItem && childItem.description === 'Encimera') {
        return
      }
    }

    if (currentObjectID && currentObjectID.startsWith('linkedItem_')) {
      const selectedItem = store.items.get(currentObjectID)
      if (selectedItem && selectedItem.type === 'linkedItem' && selectedItem.textures) {
        const doorTexture = selectedItem.textures.find((t) => t.zoneDisplayName === 'Puerta')
        if (doorTexture && doorTexture.acabado && doorTexture.acabado !== acabado) {
          setAcabado(doorTexture.acabado)
        }
      }
    }
  }, [centerInfo, highlighted])

  if (!centerInfo || centerInfo.length === 0) {
    return null
  }

  return (
    <Accordion.Root
      collapsible
      type='single'
      value={modelo}
      onValueChange={handleRootChange}
      key={highlighted}
    >
      <div className='h-[28px] bg-C/Color4 pl-2 pt-1'>{modelo}</div>
      {!isModel
        ? centerInfo.map((render, i) => {
            if (!render?.acabado || !regexp.test(render.acabado)) {
              return null
            }

            const isZocalo = modelo === 'Zocalo'

            return (
              <Accordion.Item
                key={`${highlighted}-${i}`}
                value={String(render.idAcabadoUnidadModeloAcabado)}
                onClick={() => {
                  handleGroupClick(render.idAcabadoUnidadModeloAcabado, render.acabado)
                }}
              >
                <Accordion.Header
                  className={clsx(
                    'h-[30px] cursor-pointer p-0.5 pl-2',
                    acabado === render.acabado && 'bg-C/Color2',
                  )}
                >
                  {isZocalo ? (
                    <span></span>
                  ) : (
                    <Accordion.Trigger>{render.acabado}</Accordion.Trigger>
                  )}
                </Accordion.Header>
                <Accordion.Content></Accordion.Content>
              </Accordion.Item>
            )
          })
        : null}
    </Accordion.Root>
  )
}
